/**
 * Detect and classify some device specific information via userAgent.  
 * Detects browser, browser version, os, form-factor.
 * @name Device
 */
 (function (root, factory) {
    if ((typeof define === 'function' && define.amd) && !(typeof bam !== "undefined" && typeof bam.define === "function")) {
        // AMD.
        define('device/device',[], factory);
    } else {
        // Browser globals
        root.deviceBootstrap = factory();
    }
}(this, function () {
	
	var OPEN='(',
		CLOSE=')',
		CASE='i',
		PIPE='|',

		OTHER 		= 'other',
		VERSION 	= 'version',
		EMPTY 		= "",

		Regex=function(regex,flags){return new RegExp(regex,flags||CASE)},
		ios 	="iP(?:hone|ad|od)",
		bb 		="(?:BlackBerry|BB10| RIM )",
		android ="Android",
		windows ="Windows",
		winpold = windows+" Phone",
		winphone="Trident(?:.*?Touch)",
		linux  	="Linux(?!.*Android)",
		mac 	="Macintosh",
		desktop=OPEN+"?:"+[mac,windows,linux].join(PIPE)+CLOSE,


		rSEP=/[\._]/,
		rPLATFORM={
			ios 		: Regex(ios),
			blackberry  : Regex(bb),
			android 	: Regex(android),
			windowsphone: Regex(winphone+PIPE+winpold),
			windows 	: Regex(windows),
			linux 		: Regex(linux),
			macintosh 	: Regex(mac)
		},
		rFORMFACTOR={
				/* Use Mobi for android partial match to also include Opara mobile for android
				 * @todo NT+winp can report incorrect matches for touch enabled win 8 desktop */
			tablet 	: Regex(OPEN+(['Tablet|iPad','\\sNT.*?'+winphone,android+'(?!.*Mobi)','silk',bb+'.*?Tablet'].join(PIPE))+CLOSE),
			phone 	: Regex(OPEN+['Mobi|Mobile',ios,winphone,bb].join(PIPE)+CLOSE),
			desktop : Regex(desktop)
		},
		rBROWSER 	={
			android 	: /android(?!.+(?:chrome|silk))/i,
			chrome 		: /chrome|crios/i,
			firefox 	: /firefox/i,
			opera   	: /opera(?!.*?mini)\//i,
			operamini   : /opera mini/i,
			msie     	: /msie|iemobile|trident/i,
			silk 		: /silk/i,
			safari 		: /safari/i
		},
		rBROWSERCORE ={
			webkit 		: /AppleWebKit/i,
			gecko 		: /gecko\//i,
			trident 	: /trident/i
		},
		rNOTPOLYFILL=/\[\s*native code\s*\]/,

		FORMFACTORS = {
			desktop: "desktop",
			other  : OTHER,
			phone  : "phone",
			tablet : "tablet"
		},
		deviceCache={},
		queue;

	function safeArray(ar,index){
		return ar && index ? ar[index] : ar;
	}
	function version(vstr){
		return vstr.split(rSEP).slice(0,3).join('.');
	}

	/**
	 * Build a device descriptor object via a userAgent string.  
	 * Identifies the platform, browser name and version, and os version.
	 * Attempts to classify the device's form factor as either Phone, Tablet, or Desktop.
	 * Parsed devices are cached internally to reduce processing, and provide a mechanism
	 * for updating properties on the fly as need (@see getOrientation).
	 * @constructor
	 * @param {string} [ua] Optional userAgent string to consume. Defaults to navigator.userAgent.
	 */
	function Device(ua){
		ua=ua||navigator.userAgent;
		if(deviceCache[ua]){
			return deviceCache[ua];
		}
		if(!(this instanceof Device)){
			return new Device(ua);
		}
		deviceCache[ua]=this;
		this.userAgent=ua;
		this.is={};
		this.platform=this.getPlatform();
		this.platformVersion=this.getPlatformVersion();
		this.browser=this.getBrowser();
		this.browserVersion=this.getBrowserVersion();
		this.formFactor=this.getFormFactor();
	}


	Device.prototype={
		/**
		 * Determine os from a known set of values.  If not readily classifiable, 
		 * the platform will be 'other'.
		 * @see  rPLATFORMS
		 * @return {string} Platform name or 'other'.
		 */
		getPlatform : function(){
			return this.test(rPLATFORM)||OTHER;
		},
		/**
		 * Attempt to determing the version of the parsed platform. 
		 * Version will be formatted as MAJOR.MINOR.PATCH (if availble).
		 * @return {string} Version string of the determined platform.  In unknown, value is "".
		 */
		getPlatformVersion : function() {
			return version(this.match(Regex("(?:"+ (this.is.blackberry? VERSION:this.platform )+"|OS)[^\\d]+([\\d\\.\\_]+)","ig"),1));
		},
		/**
		 * Determine the browser name from the defined set.
		 * @see  rBrowser
		 * @return {string} Matched browser name from rBrowser. Defaults to 'other'.
		 */
		getBrowser : function() {
			this.test(rBROWSERCORE);
			return (this.test(rBROWSER)||OTHER);
		},
		/**
		 * Attempt to match the device to the form factor set {tablet, phone, desktop, other} where possible.
		 * @return {string} Form factor label, or 'other'.
		 */
		getFormFactor: function() {
			return FORMFACTORS[this.test(rFORMFACTOR)]||FORMFACTORS.other;
		},
		/**
		 * Parse out the browser version as a MAJOR.MINOR.PATCH formatted string. 
		 * @note  BUILD fragment is discarded.
		 * @return {string} Parsed version string of the form MAJOR.MINOR.PATCH.
		 */
		getBrowserVersion : function() {
			var searchBrowser=this.browser;
			if(this.is.chrome && this.is.ios){
				searchBrowser="crios";
			}else if(this.is.opera){
				searchBrowser=VERSION
			}
			return version(this.match((Regex("(?:"+searchBrowser+PIPE+VERSION+")[\\/\\s]([\\d\\.]+)","ig")),1));
		},
		/**
		 * Helper method for safely running regex matches against the instances userAgent.
		 * @param  {regexp} 	regex Regex to match.
		 * @param  {number} 	[index] Optional captured match to return.  If no index is supplied, 
		 *                           	the entire match set is return as an array.
		 * @return {mixed}      String when used with index, or array of matches.
		 */
		match : function(regex,index){
			return safeArray(regex.exec(this.userAgent),index)||EMPTY;
		},
		test  : function(map){
			var key,
				check,
				result,
				ua=this.userAgent;

			for(key in map){
				check=map[key].test(ua);
				this.is[key]=this.is[key] || (check && !result);
				if(check && !result){
					result=key;
				}
			}
			return result;
		}
	};

	return Device;
}));
